import styled from "styled-components";

const Wrapper = styled.div`
  height: 55px;
  line-height: 55px;
  background-color: rgb(22, 22, 22);
  color: white;
  text-align: center;
`;

function Footer() {
  return <Wrapper>© 2023. Casper Made by jijiseong</Wrapper>;
}
export default Footer;
